var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import Box from "../../box/Box";
import Text from "../../text";
import { useAddToBag } from "../../hooks/useAddToBag";
import Button from "../../button/Button";
import ProductSelect from "onnit-ui/lib/buybox/shared/ProductSelect";
import { getProductStatus } from "onnit-ui/lib/buybox/utils";
import { ProductStatus } from "onnit-ui/lib/@types/enums/ProductStatus";
import { Img } from "../../image";
import NumberUtil from "../../utils/NumberUtil";
var CustomPackageBuyBox = function (_a) {
    var images = _a.images, name = _a.name, selectableProducts = _a.selectableProducts, packageProducts = _a.packageProducts, productNameTransform = _a.productNameTransform, imgAltText = _a.imgAltText, _b = _a.label, label = _b === void 0 ? "Select Product" : _b, children = _a.children, rest = __rest(_a, ["images", "name", "selectableProducts", "packageProducts", "productNameTransform", "imgAltText", "label", "children"]);
    var _c = useState(function () {
        selectableProducts.sort(function (a, b) {
            return a.in_stock === b.in_stock ? 0 : a.in_stock ? -1 : 1;
        });
        var inStockProducts = selectableProducts.filter(function (product) {
            return getProductStatus(product) === ProductStatus.InStock;
        });
        if (inStockProducts.length > 0) {
            return inStockProducts[0];
        }
        return selectableProducts[0];
    }), selectedProduct = _c[0], setProduct = _c[1];
    var _d = useAddToBag(), isAddingToBag = _d.isAddingToBag, addToBag = _d.addToBag;
    var allInStock = __spreadArray(__spreadArray([], packageProducts, true), [selectedProduct], false).every(function (product) { return product.in_stock; });
    var totalPrice = __spreadArray(__spreadArray([], packageProducts, true), [selectedProduct], false).reduce(function (total, product) {
        total += Number(product.price_raw);
        return total;
    }, 0);
    return (React.createElement(Box, __assign({ display: "flex", flexDirection: "column" }, rest),
        React.createElement(Img, { src: images[selectedProduct.id], mb: "2", alt: imgAltText }),
        React.createElement(Box, { flex: "1 1 auto" },
            React.createElement(Text, { as: "p", typeStyle: "title04", mb: 3 }, name),
            children,
            !allInStock && (React.createElement(Text, { as: "p", color: "gameRed", typeStyle: "text03", mt: 4 }, "Out of stock"))),
        allInStock && (React.createElement(React.Fragment, null,
            React.createElement(Text, { typeStyle: "text03", as: "p", mt: 4, mb: 2 }, NumberUtil.formatMoney(totalPrice)),
            selectableProducts.length > 1 && (React.createElement("label", null,
                React.createElement("span", { className: "sr-only" }, label),
                React.createElement(ProductSelect, { selectedProduct: selectedProduct, products: selectableProducts, productNameTransform: productNameTransform, onProductChange: setProduct }))),
            React.createElement(Button, { size: ["small", "small", "medium"], mt: 5, width: 1, display: "block", disabled: isAddingToBag, onClick: function () {
                    var configs = __spreadArray(__spreadArray([], packageProducts, true), [selectedProduct], false).map(function (product) { return ({
                        product_id: product.id,
                        quantity: 1,
                        subscription_interval: null,
                    }); });
                    addToBag(configs);
                } }, isAddingToBag ? "Adding..." : "Add to Bag")))));
};
export default CustomPackageBuyBox;
//# sourceMappingURL=CustomPackageBuyBox.js.map